import type { FC } from "react";
import Button from "@mui/material/Button";
import { useTranslation } from "@/shared/hooks";
import { openAssistant } from "../model/assistantStore";
import { useAssistantAvailable } from "../model/useAssistantAvailable";
import {
  buildAssistantErrorStart,
  type FixWithAssistantErrorCode,
} from "../lib/buildAssistantErrorStart";

export type { FixWithAssistantErrorCode };

export interface FixWithAssistantButtonProps {
  errorCode: FixWithAssistantErrorCode;
  contentId?: string | null;
  productId?: string | null;
  paymentId?: string | null;
  /** Тип и детали ошибки плеера, HTTP-код (PLAYBACK_ERROR). */
  playerError?: string | null;
}

/**
 * Кнопка «Разобраться с <имя помощника>» под экранами ошибок доступа, плеера
 * и оплаты. Клик открывает панель помощника (Task 14) с подготовленным
 * первым сообщением про конкретную ошибку. pendingStart стора сам дождётся
 * входа зрителя, если он ещё гость, и отправит сообщение после.
 *
 * Ничего не рендерит, если помощник на этой платформе выключен.
 */
export const FixWithAssistantButton: FC<FixWithAssistantButtonProps> = ({
  errorCode,
  contentId,
  productId,
  paymentId,
  playerError,
}) => {
  const { t } = useTranslation();
  const { available, name } = useAssistantAvailable();

  if (!available) return null;

  const handleClick = () => {
    openAssistant(
      buildAssistantErrorStart(t, errorCode, {
        contentId,
        productId,
        paymentId,
        playerError,
      }),
    );
  };

  return (
    <Button
      variant="text"
      size="small"
      onClick={handleClick}
      sx={{ color: "inherit" }}
    >
      {t("assistant.fixWithAssistant", { name })}
    </Button>
  );
};
